import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
});

// Bearer fallback (cookies are primary, but allow header for resilience)
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("zentra_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export function setStoredToken(token) {
    if (token) localStorage.setItem("zentra_token", token);
    else localStorage.removeItem("zentra_token");
}

export function formatApiError(err, fallback = "Algo ha ido mal. Inténtalo de nuevo.") {
    const d = err?.response?.data?.detail;
    if (d == null) return err?.message || fallback;
    if (typeof d === "string") return d;
    if (Array.isArray(d))
        return d
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" • ");
    if (d && typeof d.msg === "string") return d.msg;
    return String(d);
}

export default api;
